module.exports = __webpack_public_path__ + "img/hr-green-carpet-grass-11.db68baaa.png";